import Valorization from '@/models/valorization/filter/Valorization';
import Group from '@/models/valorization/filter/Group';
import Protocol from '@/models/valorization/filter/Protocol';
import Station from '@/models/valorization/filter/Station';
import moment from 'moment';

export default class Selected {
  public station: Station | null = null;
  public protocol: Protocol | null = null;
  public valorization: Valorization | null = null;
  public groups: Group[] | null = null;
  public dates: string[] = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
  public component: string = '';
}
